import { LookupListApiItem, UserGroupResponse } from '../api/user/model';

export interface UserDetails {
  displayName?: string;
  roles?: readonly string[];
  organisationName?: string;
  organisationAccess?: readonly OrganisationModuleAccess[];
  csrfToken?: string;
  inactivityMinutes?: number;
  serverDateTime?: string;
}

export interface OrganisationModuleAccess {
  examCode: string;
  modules: string[];
}

export enum Role {
  candidate = 'ROLE_CANDIDATE',
  coordinator = 'ROLE_COORDINATOR',
  opsAdmin = 'ROLE_OPS_ADMIN',
  sysAdmin = 'ROLE_SYSTEM_ADMIN',
}

export enum OrganisationAccess {
  resultRelease = 'MODULE_RESULT_RELEASE',
  payment = 'MODULE_PAYMENT',
  resit = 'MODULE_EXAM_RESIT',
  appeal = 'MODULE_RESULT_APPEAL',
  accessArrangement = 'MODULE_ACCESS_ARRANGEMENT',
}

export enum AccessOption {
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
}

export interface UserList {
  id: number;
  name: string;
  email: string;
  contactNumber: string;
  identity: string;
  accountStatus: string;
  lastAttemptedDateTime: string;
}

export interface IExamContent {
  raceMenuItems: LookupListApiItem[];
  citizenshipMenuItems: LookupListApiItem[];
  genderMenuItems: LookupListApiItem[];
  countryCodeMenuItems: LookupListApiItem[];
  nationalityMenuItems: LookupListApiItem[];
  designationMenuItems: LookupListApiItem[];
  salutationMenuItems: LookupListApiItem[];
}

export interface OrganisationContent {
  organisationMenuItems: {
    children: string;
    key: string;
    value: number;
  }[];
}

export interface ResitSubjectList {
  subject: string;
  subjectCode: string;
  examSeries: string;
  examLevel: string;
}

export interface Candidate {
  name: string;
  userIdType: string;
  hanyuPinyinName: string;
  identity: string;
  gender: string;
  dob: number;
  email: string;
  race: string;
  prStatus: string;
  nationality: string;
  nationalityIssueDate: number;
  citizenship: string;
  localAddressBlockNumber: number;
  localAddressUnitNumber: number;
  localAddressFloorNumber: number;
  localAddressStreetName: string;
  localAddressPostalCode: number;
  foreignAddress: string;
  foreignAddress2: string;
  foreignAddress3: string;
  occupation: string;
  school: string;
  telephoneCountryCode: number;
  telephoneNumber: string;
  mobileNumberCountryCode: number;
  mobileNumber: string;
  nextOfKinName: string;
  nextOfKinContactNumberCountryCode: number;
  nextOfKinContactNumber: number;
  nextOfKinRelationship: string;
  activeStatus: string;
  blockStatus: string;
  lockStatus: string;
}

export interface OpsAdmin {
  id: number;
  name: string;
  email: string;
  dateOfBirth: string;
  mobileNumberPrefix: string;
  mobileNumberCountryCode: number;
  mobileNumber: string;
  username: string;
  adminId: string;
  pendingRequests: boolean;
  approverRole: boolean;
  roles: UserGroupResponse[];
  lockStatus: string;
}

export interface Coordinator {
  salutation: string;
  coordinatorName: string;
  school: string;
  designation: string;
  email: string;
  contact: number;
  activeStatus: string;
  blockStatus: string;
  lockStatus: string;
}

export interface CoordinatorOrganisation {
  userId: number;
  username: string;
  coordinatorName: string;
  email: string;
  school: string;
  accountCreateDateTime: string;
  status: string;
}

export interface MyInfoTokenMutationRequest {
  code: string | null;
  state: string | null;
}

// the name of the field which MyInfo API will return
type MyInfoDataResponseItemFieldType =
  | 'name'
  | 'uinfin'
  | 'hanyupinyinname'
  | 'sex'
  | 'dob'
  | 'email'
  | 'race'
  | 'secondaryrace'
  | 'nationality'
  | 'residentialstatus'
  | 'occupation'
  | 'mobilenoAreaCode'
  | 'mobilenoPrefix'
  | 'mobilenoDigit'
  | 'homenoAreaCode'
  | 'homenoPrefix'
  | 'homenoDigit'
  | 'registeredAddressBlockNumber'
  | 'registeredAddressFloorNumber'
  | 'registeredAddressUnitNumber'
  | 'registeredAddressStreetNumber'
  | 'registeredAddressPostalCode';

export interface MyInfoDataResponseItem {
  field: MyInfoDataResponseItemFieldType;
  value: string;
  code: string;
  editable: boolean;
}

export interface OpsAdminSearch {
  id: number;
  name: string;
  email: string;
  dateOfBirth: number;
  mobileNumberPrefix: string;
  mobileNumberCountryCode: number;
  mobileNumber: string;
  username: string;
  adminId: string;
}

export interface CandidateSearch {
  id: number;
  username: string;
  name: string;
  candidateId: string;
  dateOfBirth: number;
  email: string;
  school: string;
  orgranisationId: number;
  status: string;
  createdAt: number;
  accountType: string;
}

export interface CoordinatorSearch {
  userId: number;
  username: string;
  coordinatorName: string;
  email: string;
  school: string;
  accountCreateDateTime: string;
  status: string;
  accountType: string;
}

export enum IdType {
  NRIC_OR_FIN = 'NRIC_OR_FIN',
  PASSPORT = 'PASSPORT',
}

export interface RetrieveUsernameByEmailPayload {
  userIdType: IdType;
  nricFinPassport: string;
  dateOfBirth: string;
}

export interface RetrieveUserNameByEmailResponse {
  email: string;
}
